export default __webpack_public_path__ + "static/2005-9d7d7448f5973066a44b16130410f645.png";